import(/* webpackMode: "eager" */ "/workspace/app/electronics/components/Products.jsx")